import { useState } from "react";
import { motion } from "framer-motion";
import { Send, Mic } from "lucide-react";
import { EASE, Label } from "./SlideKit";

export const QAPanel = ({ chatLog, onTypedQuestion, micLive }) => {
  const [typed, setTyped] = useState("");
  const submit = () => {
    if (typed.trim()) {
      onTypedQuestion(typed.trim());
      setTyped("");
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9, ease: EASE }}
      className="fixed left-3 right-3 sm:left-auto sm:right-10 top-14 sm:top-16 bottom-24 z-30 w-auto sm:w-96 border border-neutral-800 bg-black/70 backdrop-blur-2xl flex flex-col"
      data-testid="qa-panel"
    >
      <div className="flex items-center justify-between border-b border-neutral-800 px-5 py-4">
        <Label className="text-[#dd6611]">Q&amp;A — Ask the dossier</Label>
        <div className="flex items-center gap-2">
          <Mic size={12} className={micLive ? "text-[#dd6611]" : "text-neutral-600"} strokeWidth={1.5} />
          <span className={`w-1.5 h-1.5 rounded-full ${micLive ? "bg-[#dd6611] pulse-dot" : "bg-neutral-700"}`} />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-5 space-y-4">
        {chatLog.length === 0 && (
          <div className="text-sm font-light text-neutral-500 leading-relaxed">
            Speak, or type a question below. Xena answers strictly from the Averra Life strategy dossier.
          </div>
        )}
        {chatLog.map((m, i) => (
          <div key={i} className={m.role === "user" ? "text-right" : ""}>
            <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-neutral-600 mb-1">
              {m.role === "user" ? "You" : "Xena"}
            </div>
            <div className={`inline-block text-sm font-light leading-relaxed px-4 py-3 border ${
              m.role === "user" ? "border-neutral-700 text-white" : "border-[#dd6611]/40 text-neutral-300"
            }`}>
              {m.text}
            </div>
          </div>
        ))}
      </div>
      <div className="border-t border-neutral-800 p-4 flex gap-2">
        <input
          data-testid="qa-panel-input"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="Type a question…"
          className="flex-1 min-w-0 bg-transparent border border-neutral-800 px-4 py-2.5 text-base sm:text-sm text-white placeholder:text-neutral-600 focus:outline-none focus:border-[#dd6611] transition-colors duration-200"
        />
        <button data-testid="qa-panel-submit-btn" onClick={submit}
          className="border border-neutral-700 px-4 text-neutral-300 hover:border-[#dd6611] hover:text-white transition-colors duration-200">
          <Send size={14} strokeWidth={1.5} />
        </button>
      </div>
    </motion.div>
  );
};
